import { QrCode, Download, RefreshCw } from 'lucide-react'
import { Button } from '@/components/ui'
import { useTranslation } from 'react-i18next'

interface QRCodeHeaderProps {
  onDownloadAll: () => void
  isDownloadingAll: boolean
  hasQRCodes: boolean
}

export function QRCodeHeader({
  onDownloadAll,
  isDownloadingAll,
  hasQRCodes,
}: QRCodeHeaderProps) {
  const { t } = useTranslation()

  return (
    <header className='flex justify-between items-center border-b pb-4 mb-8'>
      <div className='flex items-center space-x-3'>
        <div className='flex items-center justify-center h-10 w-10 rounded-lg bg-white border border-gray-200 shadow-sm'>
          <QrCode className='h-6 w-6 text-gray-800' />
        </div>
        <div>
          <h1 className='text-xl font-bold text-gray-800'>
            {t('qrCode.title')}
          </h1>
          <p className='text-sm text-gray-500'>{t('qrCode.description')}</p>
        </div>
      </div>

      <Button
        type='button'
        className='h-11 font-medium bg-red-600 hover:bg-red-700'
        onClick={onDownloadAll}
        disabled={isDownloadingAll || !hasQRCodes}
      >
        {isDownloadingAll ? (
          <>
            <RefreshCw className='h-4 w-4 mr-2 animate-spin' />
            {t('qrCode.downloadAll')}
          </>
        ) : (
          <>
            <Download className='h-4 w-4 mr-2' />
            {t('qrCode.downloadAll')}
          </>
        )}
      </Button>
    </header>
  )
}
